import * as React from "react";
import * as Ons from "react-onsenui";
import { isLoading, Loading } from "../Loading";
import { CaregiverNotificationId } from "../messages";
import { NotificationType, PushNotificationInfo } from "../messages/PushNotificationMessages";
import { STRINGS } from "../strings";
import { globalize, translate } from "../translate";
import { EmptyScreenPlaceholder } from "./EmptyScreenPlaceholder";
import { ScreenSkeleton } from "./ScreenSkeleton";

interface NotificationScreenProps {
  onBackClick: () => void;
  pushNotificationInfoList: PushNotificationInfo[] | Loading;
  onNotificationClick: (notification: PushNotificationInfo) => void;
  onNotificationsViewed: () => void;
}

interface NotificationScreenState {}

export class NotificationScreen extends React.Component<
  NotificationScreenProps,
  NotificationScreenState
> {
  constructor(props: NotificationScreenProps) {
    super(props);
  }

  /**
   * Mark all notifications as viewed when leaving
   */
  componentWillUnmount() {
    this.props.onNotificationsViewed();
  }

  render() {
    function getIconClass(type: NotificationType) {
      switch (type) {
        case NotificationType.CAREGIVER_STATUS_CHANGED:
          return "NotificationScreen__reminderIcon";
        case NotificationType.VISIT_CANCEL_NOTIFICATION:
          return "NotificationScreen__availableVisitIcon";
        case NotificationType.VISIT_NOTIFICATION:
          return "NotificationScreen__availableVisitIcon";
        default:
          return "";
      }
    }

    function isNotificationNew(notification: PushNotificationInfo): boolean {
      return !notification.clicked && !notification.viewed;
    }

    function NotificationCard(props: {
      notification: PushNotificationInfo;
      onNotificationClick: (notification: PushNotificationInfo) => void;
    }) {
      return (
        <div
          className={
            "NotificationScreen__row " +
            (isNotificationNew(props.notification) ? "NotificationScreen__rowNew" : "")
          }
          onClick={() => props.onNotificationClick(props.notification)}
        >
          <div className="NotificationScreen__rowLeft">
            <div
              className={
                "NotificationScreen__rowIcon " +
                getIconClass(props.notification.pushNotification.type)
              }
            />
          </div>
          <div className="NotificationScreen__rowMiddle">
            <div className="NotificationScreen__rowMiddleNotificationText">
              {props.notification.notificationText}
            </div>
            <div>
              {globalize().formatInstant(props.notification.createdAt, { datetime: "medium" })}
            </div>
          </div>
          {isNotificationNew(props.notification) ? (
            <div className="NotificationScreen__rowNewBadgePlaceholder NotificationScreen__rowNewBadge">
              <div className="NotificationScreen__rowNewBadgeText">{translate(STRINGS.NEW)}</div>
            </div>
          ) : (
            <div className="NotificationScreen__rowNewBadgePlaceholder" />
          )}
          <div className="NotificationScreen__rowRight">
            {props.notification.pushNotification.type === NotificationType.VISIT_NOTIFICATION ? (
              <div className="NotificationScreen__arrow" />
            ) : (
              ""
            )}
          </div>
        </div>
      );
    }

    return (
      <ScreenSkeleton
        onBackClick={this.props.onBackClick}
        title={translate(STRINGS.NOTIFICATIONS)}
        titleBarStyle={ScreenSkeleton.TitleBarStyle.PRIMARY}
      >
        {isLoading(this.props.pushNotificationInfoList) ? (
          <div className="NotificationScreen__loading">
            <Ons.ProgressCircular indeterminate={true} />
          </div>
        ) : this.props.pushNotificationInfoList.length === 0 ? (
          <EmptyScreenPlaceholder placeholderText={translate(STRINGS.NO_NOTIFICATIONS)} />
        ) : (
          this.props.pushNotificationInfoList.map((notification) => {
            return (
              <NotificationCard
                key={CaregiverNotificationId.unwrap(notification.id)}
                notification={notification}
                onNotificationClick={this.props.onNotificationClick}
              />
            );
          })
        )}
      </ScreenSkeleton>
    );
  }
}
